<template>
  <div
    :class="{
      'sidebar-header': true,
      'sidebar-header--collapsed': isCollapsed,
      'is-enabled-ramadan-logo': isRamadanLogoEnabled,
    }"
  >
    <div class="sidebar-header__inner">
      <div class="partner-logo-container">
        <svg-icon icon-class="partner-logo" />
        <span class="partner-text">{{ $t('partners') }}</span>
        <svg-icon
          v-if="!isCollapsed && isRamadanLogoEnabled"
          :icon-class="ramadanLogo"
          class="ramadan-logo-decorator"
          width="18px"
          height="22px"
        />
      </div>
      <div v-if="collapseButtonVisible" class="controller-button">
        <svg-icon
          :icon-class="sidebarControllerButtonName"
          @click="handleToggleSidebar"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SidebarHeader',
  props: {
    currentLocale: {
      type: String,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    collapseButtonVisible: {
      type: Boolean,
      default: true,
    },
    isRightToLeftDirection: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRamadanLogoEnabled() {
      return (
        this.$abtProvider.isFeatureEnabled('merchant_ramadan_logo_enabled') ||
        false
      )
    },
    ramadanLogo() {
      return this.currentLocale === 'en_US'
        ? 'ramadan-logo-decorator'
        : 'ramadan-logo-decorator-ar'
    },
    sidebarControllerButtonName() {
      if (this.isRightToLeftDirection) {
        return this.isCollapsed ? 'collapse-icon-active' : 'collapse-icon'
      }

      return this.isCollapsed ? 'collapse-icon' : 'collapse-icon-active'
    },
  },
  methods: {
    handleToggleSidebar() {
      const event = this.isCollapsed ? 'click:expand' : 'click:collapse'

      this.$emit(event)
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar-header {
  padding: 24px;
  line-height: 29px;

  &.is-enabled-ramadan-logo {
    padding: 28px 24px 20px 24px;
  }

  &__inner {
    display: flex;
    align-items: center;
    height: 29px;
    font-size: 22px;
    font-weight: 700;
    line-height: 29px;

    .partner-logo-container {
      position: relative;
      display: flex;
      gap: 8px;
      align-items: center;
      margin-inline-end: auto;

      .partner-text {
        flex: 1 1 auto;
      }

      .ramadan-logo-decorator {
        position: absolute;
        top: -12px;
        right: -12px;

        [dir='rtl'] & {
          top: -5px;
          right: auto;
          left: -22px;
        }
      }
    }

    .controller-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      padding: 4px;
      font-size: 16px;
      color: #8267db;
      cursor: pointer;
      background-color: #fff;
      border-radius: 6px;
      transition: all 0.3s linear;

      &:hover {
        color: #fff !important;
        background-color: #8267db !important;
        transition: all 0.3s linear;
      }
    }
  }
}
</style>
